import { adsMidRed } from "../utils/ADSColours";

const HWWDesignationCode = [
  {
    id: 1,
    gpText: "Height Restriction",
    colour: adsMidRed,
    default: false,
  },
  {
    id: 2,
    gpText: "Width Restriction",
    colour: adsMidRed,
    default: false,
  },
  {
    id: 3,
    gpText: "Weight Restriction",
    colour: adsMidRed,
    default: false,
  },
];

export default HWWDesignationCode;
